export function getCurrentRoute() {
  const currentPath = window?.location?.pathname || '';
  const isPath = (path) => currentPath === path;
  return { isPath, currentPath };
}
